<template>
  <div>
    <el-form :model="changeForm" :rules="rules" ref="formRef" label-width="120px">
      <el-form-item label="变更类型" prop="changeType">
        <el-radio-group v-model="changeForm.changeType">
          <el-radio label="1">变更</el-radio>
          <el-radio label="2">新增</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="选中单据" prop="changeContent">
        <el-input v-model="changeForm.changeContent" type="textarea" :autosize="{ minRows: 2, maxRows: 4 }"></el-input>
      </el-form-item>
    </el-form>
    <el-dialog-footer>
      <el-button type="primary" @click="submitForm('formRef')">确定</el-button>
      <el-button @click="resetForm('formRef')">重置</el-button>
    </el-dialog-footer>
  </div>
</template>
<script>
export default {
  name: "change-dialog",
  data() {
    return {
      changeForm: {
        changeType: "",
        changeContent: "",
      },
      rules: {
        changeType: [{ required: true, message: "请选择变更类型", trigger: "blur" }],
        changeContent: [{ required: true, message: "请输入变更内容", trigger: "blur" }],
      },
    };
  },
  methods: {
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.$emit("submit", this.changeForm);
        } else {
          console.log("校验失败");
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
      this.changeForm.changeType = "";
      this.changeForm.changeContent = "";
    },
  },
}
</script>
